import React, { useEffect } from "react";
import styles from "./news.module.css";
import { useNavigate, useParams, useLocation, Link } from "react-router-dom";
import { setMetaTags } from "../../utils/util_functions";
import { CLEAR_PATH_PARAMS } from "../../services/actions/path_params_actions";
import { useDispatch, useSelector } from "react-redux";
import { getNews, getCurrNews, getLoading } from "../../services/selectors";
import {
  getDataFromArrayWithSlug, paragraphListFromNews, imagesAndNamesFromNews
} from "../../utils/util_functions";
import { CURR_NEWS_DEL, getNewsThunk } from "../../services/actions/curr_news_actions";
import news_image_default from "../../images/news_image_default.png";
import { SET_PORTAL_SLIDESHOW } from "../../services/actions/portal_actions";
import Loader from "../../components/loader/loader";


const NewsPage = () => {

  const { token } = useParams();
  const { news } = useSelector(getNews);
  const currNews = useSelector(getCurrNews);
  const navigate = useNavigate();
  const location = useLocation();
  const isLoading = useSelector(getLoading);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: CLEAR_PATH_PARAMS });
    // eslint-disable-next-line
  }, [location]);

  const {
    metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromArrayWithSlug(token, news);

  const paragraphs = paragraphListFromNews(currNews);
  const imagesAndNames = imagesAndNamesFromNews(currNews);

  setMetaTags(
    metaTitle, metaDescription,
    metaKeywords, metaRobots
  );

  useEffect(() => {
    dispatch(getNewsThunk(token, navigate));
    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch({ type: CURR_NEWS_DEL })
    }
    // eslint-disable-next-line
  }, []);

  const defaultImageHandler = (e) => {
    e.target.src = news_image_default;
  }

  const handleClickImage = (e) => {
    dispatch({
      type: SET_PORTAL_SLIDESHOW,
      images: imagesAndNames,
      index: imagesAndNames.findIndex(item => item.image === e.target.id)
    });
  }

  const handleMouseMove = (e) => {
    const positionY = e.nativeEvent.offsetY;
    const positionX = e.nativeEvent.offsetX;
    const statusY = positionY > e.target.clientHeight * 0.7 ? 'YBottom' : (positionY < e.target.clientHeight * 0.3 ? 'YTop' : 'YCenter');
    const statusX = positionX > e.target.clientWidth * 0.7 ? 'XRight' : (positionX < e.target.clientWidth * 0.3 ? 'XLeft' : 'XCenter');
    if (statusY === 'YTop' && statusX === 'XCenter') {
      e.target.className = styles.imgYTop;
      return;
    }
    if (statusY === 'YBottom' && statusX === 'XCenter') {
      e.target.className = styles.imgYBottom;
      return;
    }
    if (statusY === 'YCenter' && statusX === 'XRight') {
      e.target.className = styles.imgXRight;
      return;
    }
    if (statusY === 'YCenter' && statusX === 'XLeft') {
      e.target.className = styles.imgXLeft;
      return;
    }
    e.target.className = styles.img;
    return;
  }

  return (
    <main className='main'>
      {isLoading ? <Loader /> : null}
      <div className={styles.paragraphList}>
        <span className={styles.info}>
          {currNews.created}
        </span>
        <h1 className="title">{currNews.name}</h1>
        {Object.keys(currNews).length > 0 && currNews.products.length > 0 &&
          <div className={styles.productLinkContainer}>&emsp;&emsp;
            <h2 className={styles.subtitle}>
              {`Товары в ${currNews.news ? 'новости' : 'статье'}:`}
            </h2>
            {currNews.products.map((item, index) =>
              <Link to={item.path}
                className={styles.productLink}
                // target="_blank"
                key={index}
              >
                {item.name}
              </Link>
            )}
          </div>
        }
        {paragraphs.map((item, index) => {
          if (item.paragraph || item.image_1 || item.image_2) {
            return (
              <div className={styles.paragraphContainer} key={index}>
                {item.paragraph && <p className={styles.paragraph}>&emsp;&emsp;{item.paragraph}</p>}
                {(item.image_1 || item.image_2) &&
                  <div className={styles.imagesContainer}>
                    {item.image_1 &&
                      <img src={item.image_1} alt={item.image_1_name}
                        className={styles.img} onError={defaultImageHandler}
                        onClick={handleClickImage} id={item.image_1}
                        onMouseMove={handleMouseMove}
                      />
                    }
                    {item.image_2 &&
                      <img src={item.image_2} alt={item.image_2_name}
                        className={styles.img} onError={defaultImageHandler}
                        onClick={handleClickImage} id={item.image_2}
                        onMouseMove={handleMouseMove}
                      />
                    }
                  </div>
                }
              </div>
            );
          }
          return null;
        }
        )}
      </div>
    </main>
  );
};

export default NewsPage;
